export * from './SocrativeLogo';
export * from './SocrativeLoginLogo';
